import Vue from 'vue'
import Vuex from 'vuex'
import markets from './modules/markets'
import page from './modules/page'
import theme from './modules/theme'
import search from './modules/search'
import user from './modules/user'

Vue.use(Vuex);

export const store = new Vuex.Store({
	modules: {
		markets,
		page,
		theme,
        search,
        user
	},
	state:{
		user:{
			id:'',
			name:'',
			token:'',
			image:'',
			locale:''
		},
		loginModal: false,				//是否显示登录模态框
	},
	mutations: {
		setToken(state, payload){
            if(payload.hasOwnProperty('name')){
                state.user.token = payload.name
            }
        },
        setUserName(state, payload){
            if(payload.hasOwnProperty('name')){
                state.user.name = payload.name
            }
        },
        setUserId(state, payload){
            if(payload.hasOwnProperty('name')){
                state.user.id = payload.name
            }
        },
        setImage(state, payload){
            if(payload.hasOwnProperty('name')){
                state.user.image = payload.name
            }
        },
        setLocale(state, payload){
            if(payload.hasOwnProperty('name')){
                state.user.locale = payload.name
            }
        },
    },
})



// WEBPACK FOOTER //
// ./src/store/store.js